const apiVersion = 'v1'

export const BASE_PATH = `api/${apiVersion}/conciliation-execution-logs/`
export const CLIENT_CONCILIATION_EXECUTION_LOG_PATH = `api/${apiVersion}/clients/:client_session_id/conciliations/`
